export function resizeImage(url, width = 500, height = 500) {
    return `${url}?height=${height}&width=${width}`
}
